export default "__VITE_ASSET__D0nQ8wbr__"